export const SCROLL_VISIBILITY_ACTION_TYPES = {
  ADD_ELEMENT: 'ADD_ELEMENT',
  SET_VISIBILITY: 'SET_VISIBILITY',
  SET_OBSERVER: 'SET_OBSERVER',
  CLEAR_OBSERVER: 'CLEAR_OBSERVER',
};
